import { FC, useMemo } from 'react';

import { AvatarTypes, Chips, IChipsItem, TAvatarBackgroundColorIndex } from '@gem/ui-kit';

import { Avatar } from 'APP/components/Avatar/Avatar';

export interface IChipsWithAvatarItem {
  id: string;
  avatarTitle: string;
  avatarUrl: string;
  avatarColorIndex: TAvatarBackgroundColorIndex;
  title: string;
}

export interface IChipsWithAvatarProps {
  chips: IChipsWithAvatarItem[];
  onRemove(item: IChipsWithAvatarItem): void;
}

export const ChipsWithAvatar: FC<IChipsWithAvatarProps> = (props) => {
  const { chips, onRemove } = props;

  const chipsItems: IChipsItem[] = useMemo(
    () =>
      chips.map((item) => ({
        id: item.id,
        prefix: (
          <Avatar
            type={AvatarTypes.Round_0}
            title={item.avatarTitle}
            url={item.avatarUrl}
            backgroundColorIndex={item.avatarColorIndex}
          />
        ),
        title: item.title,
      })),
    [chips]
  );

  return (
    <Chips
      chips={chipsItems}
      keyExtractor={(item): string => item.id}
      onRemove={onRemove}
    />
  );
};
